import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { AppConstants } from 'src/app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-update-picture',
  templateUrl: './update-picture.component.html',
  styleUrls: ['./update-picture.component.css'],
  providers: [NgxSpinnerService]
})
export class UpdatePictureComponent {
  @Input() set userToChangePicture(value: any) {
    this.picturePreview = value.photo;
    this._userToChangePicture = value;
  }

  private _userToChangePicture: any = this.route.snapshot.paramMap.get('id');
  profilePicture: File;
  picturePreview: any;
  pictureExists: boolean;
  user: any= {
    firstName: "",
    lastName: ""
};

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public functionsService: FunctionsService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService) { }

  lang = localStorage.getItem('language')?localStorage.getItem('language'):'en';

  ngOnInit(){
    this.getUser();
    this.picturePreview = this.route.snapshot.paramMap.get('photo');
    if(this.picturePreview){
      this.pictureExists = true;
    }
    else{
      this.pictureExists = false;
    }
  }

  handleProfilePictureUpload(files: FileList) {
      document.getElementById("doc-err").innerText = "";
      this.translate.onLangChange.subscribe(() => {
      document.getElementById("doc-err").innerText = "";
    });
      if (files.item(0).size > 5000000) {
        document.getElementById("doc-err").innerHTML = this.translate.instant('profile.img_upload_size_err');
        this.translate.onLangChange.subscribe(() => {
            document.getElementById("doc-err").innerHTML = this.translate.instant('profile.img_upload_size_err');
        });
      }
      else if(AppConstants.imageFormats.includes(files.item(0).type)){
        this.profilePicture = files.item(0);
        const reader = new FileReader();
        reader.onload = () => this.picturePreview = reader.result;
        document.getElementById("fileLabel").innerHTML = this.profilePicture.name;
        reader.readAsDataURL(this.profilePicture);
      }
      else {
        document.getElementById("doc-err").innerText = this.translate.instant("error.image_format");
        this.translate.onLangChange.subscribe(() => {
          document.getElementById("doc-err").innerText = this.translate.instant("error.image_format");
      });
      }
  }

  saveProfilePicture() {
    this.spinner.show();
      this.functionsService.resizeImage(this.profilePicture, 600, 600).then(blob => {
        var file = new File([blob], "name");
      this.apiService.uploadProfilePicture(this._userToChangePicture, file)
     .subscribe(
      ()=>{
        this.spinner.hide();
        this.router.navigateByUrl('/main/users');
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    ); 
    });
  }

  isBreadcrumbFinal(breadcrumb: string): any {
    return (breadcrumb === "editPicture") ? true : false;
}

  getUser() {
    this.spinner.show();
    this.apiService.getProfile(this._userToChangePicture)
        .subscribe(
            data => {
                this.user = data;
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
}

  deleteUserPic(){
    this.spinner.show();
    this.apiService.deleteUserPic(this._userToChangePicture).subscribe(
      () => {
        this.spinner.hide();
        this.router.navigateByUrl('/main/users');
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }
}
